import {
  PrimaryGeneratedColumn,
  Column,
  JoinColumn,
  ManyToOne,
  Entity,
  Index,
} from "typeorm";
import { AdhocAgreement, User } from ".";

@Entity()
export class AdhocFile {
  @PrimaryGeneratedColumn() id: number;

  @Index()
  @Column("varchar")
  key: string;

  @Column("varchar")
  name: string;

  @Column("varchar")
  contentType: string;

  @ManyToOne(() => User)
  @JoinColumn()
  createdBy: User;

  @ManyToOne(() => AdhocAgreement)
  @JoinColumn()
  adhocAgreementId: AdhocAgreement;

  @Column("datetime") createdAt: Date;
}
